export const IcSms = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.3335 2.50928L30.3149 16L3.3335 29.4907V18.6472L7.03954 16L3.3335 13.3528V2.50928ZM9.76078 17.3333L6.00016 20.0195V25.1759L21.6854 17.3333H9.76078ZM21.6854 14.6667H9.76078L6.00016 11.9805V6.82403L21.6854 14.6667Z" fill="#C52884"/>
    </svg>
  );
};